<template>
	<div :class="blockClasses" :style="customStyles">
		<div class="recht-block-base" :class="rootClasses">
			<div class="container">
                <h2 v-if="data.title && data.title.length" :class="`recht-title recht-text-${data.textAlignment}`">
					{{ data.title }}
				</h2>
				<div v-if="data.text" :class="`recht-richtext recht-text-${data.textAlignment}`" v-html="data.text"></div>
				<div v-if="iconsArr.length" :class="`row ${rowJustify}`">
					<div v-for="(icon, index) in iconsArr" :key="`icon-${index}-${_uid}`" class="col-lg-4 col-sm-6">
						<a v-if="icon.url && icon.url.length" :href="icon.url" target="_blank" class="recht-col-content">
							<img v-if="icon.icon && icon.icon.length" loading="lazy" :src="icon.icon" class="recht-fields-margin" />
							<h6 v-if="icon.title && icon.title.length" :class="`recht-fields-margin recht-text-${data.textAlignment}`">
								{{ icon.title }}
							</h6>
							<p v-if="icon.text && icon.text.length" :class="`recht-fields-margin recht-text-${data.textAlignment}`">
								{{ icon.text }}
							</p>
						</a>
						<div v-else class="recht-col-content">
							<img v-if="icon.icon && icon.icon.length" loading="lazy" :src="icon.icon" class="recht-fields-margin" />
							<h6 v-if="icon.title && icon.title.length" :class="`recht-fields-margin recht-text-${data.textAlignment}`">
								{{ icon.title }}
							</h6>
							<p v-if="icon.text && icon.text.length" :class="`recht-fields-margin recht-text-${data.textAlignment}`">
								{{ icon.text }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Banner',
	props: {
		data: {
			type: Object,
			default: () => {},
		}
	},
	components: {},
	computed: {
		customStyles() {
			if (this.data?.backgroundImage?.length) return {
				['background-image']: `url('${this.data.backgroundImage}')`,
				['background-repeat']: 'no-repeat',
				['background-position']: 'center center',
				['background-size']: 'cover'
			}

			return {};
		},
        rootClasses() {
            return {}
        },
		iconsArr() {
			if (this.data?.icons && Array.isArray(this.data.icons)) return this.data.icons;

			let result = [];

			if (this.data?.icons && typeof this.data.icons == 'object' && Object.keys(this.data.icons) > 0) Object.keys(this.data.icons).forEach(icon => {
				result.push(icon);
			});

			return result;
		},
		rowJustify() {
			let result = 'justify-content-';
			
			if (this.data?.iconsAlignment?.length) {
				switch (this.data.iconsAlignment) {
					case 'center':
						result += 'center';
						break;
					case 'right':
						result += 'end';
						break;
					default:
						result += 'start';
				}
			}

			return result;
		},
		blockClasses() {
			let result = {
				['recht-block']: true,
				['recht-icons-block']: true
			}

			if (this.data?.backgroundImage?.length) result['has-background'] = true;

			return result;
		}
    }
}
</script>

<style lang="scss" scoped>
	.recht-icons-block {
		.container > *:not(:last-child) {
			margin-bottom: 1rem;
		}

		.row {
			margin-top: calc(-30px - (1rem - 30px));

			> div {
				margin-top: 30px;
			}
		}

		.recht-col-content {
			display: flex;
			flex-direction: column;
			align-items: center;
			text-decoration: none;
			color: #000;

			img {
				width: 60px;
				height: 60px;
				object-fit: contain;
				object-position: center;
				margin-bottom: 1rem;
			}

			h6 {
				margin-bottom: 0.5rem;
			}

			p {
				margin-bottom: 0;
			}
		}
	}
</style>
